import styled from "styled-components";
import { Form } from "antd";

const { Item: AntItem } = Form;

export const Item = styled(AntItem)`
  margin-bottom: 5px;
  flex: 1;
`;
